export default __webpack_public_path__ + "static/screen_img-4bdf673fd10d7d9a08601de4ab2da3da.png";